import clamp from "clamp-js";
import { debounce } from "underscore";


export class Breakdown {
    defaultOptions = {
        clamp: 5,
        useNativeClamp: true
    };

    constructor(el, options) {
        this.el = el;
        this.options = options || {};

        this.init();
    };

    init() {
        const els = $(this.el);

        if (!els.length) {
            return;
        }

        const config = {...this.defaultOptions, ...this.options};

        this.ellipsize(els, config);

        $(window).resize(debounce(() => {
            this.ellipsize(els, config);
        }, 200));
    };

    ellipsize(items, options) {
        const len = items.length;
        let i = 0;
        while (++i <= len) {
            clamp(items.get(i - 1), options);
        }
    };
}
